import { Avatar, Box, Divider, HStack, Heading, VStack, Wrap, WrapItem } from "@chakra-ui/react";
import React from "react";
import Email_Icon_Black from "src/resources/icons/Email_Icon_Black.svg";
import { EditIcon } from "src/resources/icons";

export type FamilyMemberCardProps = {
  name: string;
  relation: string;
  email?: string | null;
  isOpenedFromAdmin: boolean;
  onEdit?: () => void;
};

export const FamilyMemberCard: React.FC<FamilyMemberCardProps> = ({
  name,
  relation,
  email,
  isOpenedFromAdmin,
  onEdit,
}) => {
  return (
    <Box
      padding="16px 21px"
      borderRadius="14px"
      border="1px solid rgba(108, 117, 125, 0.10)"
      boxShadow="0px 21px 46px 0px rgba(135, 135, 135, 0.10)"
    >
      <HStack spacing="4" alignItems="center" justifyContent="space-between">
        <Wrap>
          <WrapItem>
            <Avatar
              boxShadow="0px 14px 38px rgba(0, 0, 0, 0.1)"
              size="lg"
              src="https://bit.ly/broken-link"
            />
          </WrapItem>
        </Wrap>
        <VStack alignItems="flex-start" textAlign="left" flex="1">
          <Heading fontSize="24px">{name || "—"}</Heading>
          <Heading fontSize="22px" color="#6C757D">
            {relation || "—"}
          </Heading>
        </VStack>
        {!isOpenedFromAdmin && onEdit && <EditIcon onClick={onEdit} />}
      </HStack>

      {email && (
        <>
          <Divider my="1rem" height="1px" backgroundColor="#6C757D" />
          <HStack>
            <img alt="email" src={Email_Icon_Black} />
            <Heading fontSize="22px" color="#6C757D">
              {email}
            </Heading>
          </HStack>
        </>
      )}
    </Box>
  );
};

export default FamilyMemberCard;
